import { type AxiosResponse, HttpStatusCode } from 'axios';
import { client } from '@/api/http';
import { downloadFromPresignedLink } from '@/api/downloadLink';

export interface ApiSurgicalGuideOrder {
    id: number,
    case_id: number,
    plan_id: number,
    state: string,
    surgical_guide_preferences_id: number | null,
    surgery_date: string,
    created_at: string,
    created_by: number,
    updated_at: string,
    updated_by: number,
    scans_last_downloaded_at: string | null,
    models_last_downloaded_at: string | null,
}

export interface ApiSurgicalGuideOrdersObject {
    items: ApiSurgicalGuideOrder[];
}

export interface MakeSurgicalGuideOrderRequest {
    plan_id: number;
}


export async function getSurgicalGuideOrders(caseId: number): Promise<ApiSurgicalGuideOrdersObject> {
    return client
        .get(`/cases/${ caseId }/surgical-guide-orders`)
        .then(({ status, data }: AxiosResponse<ApiSurgicalGuideOrdersObject>) => {
            if (status === HttpStatusCode.Ok) {
                return data;
            }
            throw Error(`Failed to load surgical guide orders: ${ caseId }`);
        });
}

export async function makeSurgicalGuideOrder(caseId: number, planId: number): Promise<ApiSurgicalGuideOrder> {
    const request: MakeSurgicalGuideOrderRequest = { plan_id: planId };
    return client
        .post(`/cases/${ caseId }/surgical-guide-orders`, request)
        .then(({ status, data }: AxiosResponse<ApiSurgicalGuideOrder>) => {
            if (status === HttpStatusCode.Created) {
                return data;
            }
            throw Error(`Failed to create surgical guide order for case: ${ caseId }`);
        });
}

export async function getZippedDicoms(caseId: number, orderId: number): Promise<void> {
    await downloadFromPresignedLink(`/cases/${caseId}/surgical-guide-orders/${orderId}/scans`);
}

export async function getSurgicalGuideModels(caseId: number, orderId: number): Promise<void> {
    await downloadFromPresignedLink(`/cases/${ caseId }/surgical-guide-orders/${ orderId }/models`);
}